import React from "react";
import { CaseProvider } from "../context/CaseContext";
import EditorContent from "./EditorContent";

export default function Editor({ user, caseId, onBack }: any) {
  return (
    <CaseProvider
      user={user}
      caseId={caseId}
      onBack={onBack}
    >
      <EditorContent />
    </CaseProvider>
  );
}
